import React from 'react'
import Timeline from 'react-timelines'
import './timeline.css';

import 'react-timelines/lib/css/style.css' // Crucial: Import the library's CSS

const PublishingWorkflow = () => {

    return (
        <>
            <div className="container">
                {/* <h2 className="pb-3 pt-2 border-bottom mb-5">Vertical Left-Right Timeline</h2> */}
                <div className='page-title-container pt-0 mb-4'>
                    <h2>Steps to Add Book</h2>
                </div>
                <div className="row align-items-center how-it-works d-flex">
                    <div className="col-2 text-center bottom d-inline-flex justify-content-center align-items-center">
                        <div className="circle font-weight-bold">1</div>
                    </div>
                    <div className="col-9">
                        <h5>Add Book Category</h5>
                        <p>Before adding a book, you must tell the system what kind of book it is (for example: Novel, Poetry, or History). You need to do this first so your books stay organized in the right sections.</p>

                    </div>
                </div>
                <div className="row timeline">
                    <div className="col-2">
                        <div className="corner top-right"></div>
                    </div>
                    <div className="col-8">
                        <hr />
                    </div>
                    <div className="col-2">
                        <div className="corner left-bottom"></div>
                    </div>
                </div>
                <div className="row align-items-center justify-content-end how-it-works d-flex">
                    <div className="col-9 text-right">
                        <h5>Add Author</h5>
                        <p>Next, you need to create a profile for the writer. You will need to enter their name, a short biography, and upload their photo. The system needs the author's profile ready so you can "link" them to their books in the next step.
                        </p>
                    </div>
                    <div className="col-2 text-center full d-inline-flex justify-content-center align-items-center">
                        <div className="circle font-weight-bold">2</div>
                    </div>
                </div>
                <div className="row timeline">
                    <div className="col-2">
                        <div className="corner right-bottom"></div>
                    </div>
                    <div className="col-8">
                        <hr />
                    </div>
                    <div className="col-2">
                        <div className="corner top-left"></div>
                    </div>
                </div>
                <div className="row align-items-center how-it-works d-flex">
                    <div className="col-2 text-center top d-inline-flex justify-content-center align-items-center">
                        <div className="circle font-weight-bold">3</div>
                    </div>
                    <div className="col-9">
                        <h5>And Now you can add Boks</h5>
                        <p>This is the final step. Now you can upload the book cover, set the price, and write the book's description. At the bottom of the form, you will simply select the Category and the Author you created in the previous steps to complete the process.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PublishingWorkflow